<template>
  <div class="text-field" :class="label ? 'pt-4' : null">
    <span class="text--m">{{label}}</span>
    <input
      class="text--m"
      :style="inputStyle"
      v-model="internalValue"
      @change="$emit('change', internalValue)"
      :readonly="readonly"
      :type="type"
      @focus="$emit('focus')"
      @blur="$emit('blur')"
    />

    <div v-if="type === 'number'" class="currency" :class="label ? 'pt-4' : null">{{ currency }}</div>
  </div>
</template>

<script>
import numeral from "numeral";

export default {
  name: "text-field",
  props: {
    value: {
      type: [Number, String]
    },
    label: {
      type: String,
      default: ''
    },
    readonly:{
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'text'
    },
    symbol: {
      type: String,
      default: ''
    },
    width: {
      type: [Number, String]
    }
  },

  data () {
    return {
      lazyValue: this.value,
      hasMouseDown: false,
    }
  },

  watch: {
    value (val) {
      this.lazyValue = val
    },
  },

  computed: {
    // Proxy for `lazyValue`
    // This allows an input
    // to function without
    // a provided model
    internalValue: {
      get() {
        return this.lazyValue
      },
      set(val) {
        this.lazyValue = val
        this.$emit('input', val)
      },
    },
    currency() {
      if (this.type === 'number') {
        return this.symbol + numeral(this.internalValue).format('0,0.[00]');
      }
      return '';
    },
    inputStyle() {
      return this.width !== undefined ? { width: typeof this.width === 'number' ? `${this.width}px` : this.width } : {};
    },
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/SelfService/colors.scss";

.text-field{
  position: relative;
  //padding-top: 32px;
  //width: 100%;
}

input{
  color: $secondary;
  padding: 10px;
  background-color: $background;
  border: 1px solid $secondary;
  box-sizing: border-box;
  border-radius: 12px;

  &[type='number'] {
    color: transparent;

    &:focus,
    &:active {
      color: #222;
    }
  }
}

span{
  position: absolute;
  top: 0;
  color: $primary;
}

.currency {
  position: absolute;
  user-select: none;
  pointer-events: none;
  top: 8px;
  left: 10px;
}

input:active,
input:focus {
  ~ .currency {
    left: -99999px;
    visibility: hidden;
  }
}
</style>
